import { render, staticRenderFns } from "./BankDecisionFormFrame.vue?vue&type=template&id=2d7b91d2&scoped=true&"
import script from "./BankDecisionFormFrame.vue?vue&type=script&lang=js&"
export * from "./BankDecisionFormFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b91d2",
  null
  
)

export default component.exports